import React from 'react'
import Card from '../components/card'
import FormGroup from '../components/form-group';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import moment from 'moment';
import SelectMenu from '../components/selectMenu';
import ClipLoader from "react-spinners/ClipLoader";
import ExportacaoService from '../app/service/exportacaoService';
import { mensagemErro} from '../components/toastr';
import {AuthContext} from '../main/provedorAutenticacao';
import CardGroup from '../components/card-group';
import ptBR from 'date-fns/locale/pt-BR';
import 'primeicons/primeicons.css';


class ExportacaoDados extends React.Component{
 
    state = {
        dataInicio: null,
        dataFim: null,
        cliente: '',
        loading:false,
        disabled:false,
        mensagem:''
    }

    constructor(){
        super();
        this.service = new ExportacaoService();
    }

    limpar = ()=> {
        this.setState({
            mensagem:'',
            dataInicio: null,
            dataFim: null,
            cliente: ''
        });
    }

    validar(){
        let msgs = [];

        if (!this.state.dataInicio) {
            msgs.push('O campo inicio período é obrigatório.')
        }

        if (!this.state.dataFim) {
            msgs.push('O campo fim período é obrigatório.')
        }

        if (!this.state.cliente) {
            msgs.push('O campo cliente é obrigatório.')
        }

         if (this.state.dataInicio &&  this.state.dataFim && (this.state.dataFim < this.state.dataInicio)) {
            msgs.push('data fim do período deve ser maior que a data início.')
        }

        return msgs;
    }


    exportar = async () => {
        this.setState({loading: true,
            disabled:true})

        const dadosConsulta = {
             dataInicio: moment(this.state.dataInicio).format('DD/MM/yyyy'),
             dataFim: moment(this.state.dataFim).format('DD/MM/yyyy'),
             cliente: this.state.cliente
        }

        try{
            const response = await this.service.gerarExportacaoPorCliente(dadosConsulta)
            this.setState({mensagem:response.data});
        }catch( erro){
            mensagemErro(erro.response.data)
        }finally{
            this.setState({loading: false,
                disabled:false})
        }
    }

    consultar = () => {
    
        this.setState({mensagem:''});

        const msgs = this.validar();
        const size = msgs.length;
  //      alert('msgs.length ', msgs.length > 0);
        if (msgs.length > 0){
            msgs.forEach( (msgs, index) =>{
                mensagemErro(msgs)
            } )
          // return false;
        } else{
            this.exportar();
        }
 
      
    }

     render(){
        const tipoCliente = [
            {label:'Selecione...', value:''},
            {label:'Boa Vista', value:'BOAVISTA'},
            {label:'Serasa', value:'SERASA'}
        ]

        return (
           <form>
            
           <Card title="Exportar Dados">
            <fieldset disabled ={this.state.disabled}>
             <div className="row">
               <div className="col-md-8 fildeset-form">                     
                    <div className="bs-component">
                        <br/>
                        <CardGroup title="Última alteração ou digitação ocorrida em:"> 
                            {/* <FormGroup label="Período da consulta: *"  htmlFor="inputNome">     */}
                            <FormGroup label="Período da consulta: *"  htmlFor="inputNome" >    
                               <div className="row col-md-12">
                                    <div className="col-md-3">
                                            <DatePicker 
                                                selected={this.state.dataInicio} 
                                                onChange={date => this.setState({dataInicio: date})} 
                                                className="form-control"  
                                                id="iniDate"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText = "Data Início"
                                                locale = {ptBR}
                                            />
                                    </div>

                                    <div className="col-md-3">
                                            <DatePicker 
                                                selected={this.state.dataFim} 
                                                onChange={date => this.setState({dataFim: date})} 
                                                className="form-control"  
                                                id="fimDate"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText = "Data Fim"
                                                locale = {ptBR}
                                             />
                                    </div>

                                </div>
                                <br/>
                                <div className="row col-md-12" style={{color: "blue"}}>
                                     {this.state.mensagem}
                                </div>
                            
                            </FormGroup>
                         </CardGroup>
                            <ClipLoader loading={this.state.loading} size={150} />
                            <br/>
                            <FormGroup label="Cliente: *"  htmlFor="inputCli">   
                                <SelectMenu 
                                    id="inputCli" 
                                    onChange= {e => this.setState({cliente: e.target.value})} 
                                    className="form-control"  
                                    lista={tipoCliente}
                                    value={this.state.cliente} />
                             
                             </FormGroup>
                              <br/>
                            <button onClick={this.consultar} className="btn btn-success">
                                <i className="pi pi-undo"> </i> Exportar
                            </button>
                            <button onClick={this.limpar} type="button" className="btn btn-danger">
                                <i className="pi pi-times"> </i> Limpar
                            </button>
                      </div>
                </div>
               </div> 
               </fieldset>
            </Card>
       
            </form> 
        )

    }
}

ExportacaoDados.contextType = AuthContext;

export default ExportacaoDados;

